import axios from "axios";

const url = process.env.REACT_APP_API_URL_HONEST
const contentType = 'application/json'

export default class HonestService {

    cekHaccp(nomorHaccp){
        let par1 = 'ff8f44c181153adbe4d12d1cf2fdde2e'
        let par2 = 'GETDATA-HACCPKKP'
        let jsonData = {
            'par1' : par1,
            'par2' : par2,
            'par3' : nomorHaccp
        }
        let data = JSON.stringify(jsonData)
        console.log(data)

        return axios.post(url + '/api_cekhaccp.php', data, {
            headers: {
                'Content-Type' : contentType
            },
        })
    }

}